import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/procedures/${id}`)
                    .then((res) => {
                        resolve(res.data.data.procedure);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        listAppliedToMedicalForms(_) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/medico/procedures/applied_to_medical_forms")
                    .then((res) => {
                        resolve(res.data.data.datas);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/medico/procedures", data)
                    .then((res) => {
                        resolve(res.data.data.procedure);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/procedures/${data.id}`, data)
                    .then((res) => {
                        resolve(res.data.data.procedure);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete(_, procedureId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/medico/procedures/${procedureId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        removeModifier(_, procedureId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/medico/procedures/${procedureId}/modifier`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        addModifier(_, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/procedures/${payload.procedureId}/modifier/${payload.modifierId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore(_, procedureId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/procedures/${procedureId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
